
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/application-development",
      function () {
        return require("private-next-pages/download/application-development/index.tsx");
      }
    ]);
  